/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-05 12:08:26
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-23 12:14:33
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/ProductSet/Stock/ProductSetStockSection.tsx
 */
import React from 'react';
import Stock from '../../Components/Stock/Stock';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
const StockSection = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  //  const stock = useSelector((state: any) => state.productSet.stock);

  return (
    <Stock
      title={getI18n('allProducts.addproductset.stock_title')}
      secondTitle={getI18n('allProducts.addproductset.stock_secondtitle')}
      //data={stock}
      // setData={setData}
      // type={EnumProductType.Set}
      // maximum={availableAmount}
      // quotaAmount={quotaAmount}
      inventoryUuid={props.uuid}
      form={props.form}
      disabled={props.disabled}
      // onSalesChannelAvailableChange={_onSalesChannelAvailableChange}
      // onSalesChannelPresaleChange={_onSalesChannelPresaleChange}
      // salesChannelAvailableQuantity={salesChannelAvailableQuantity}
      // salesChannelAvailablePresaleQuantity={
      //   salesChannelAvailablePresaleQuantity
      // }
      // checkQuantityAndLeftValid={checkQuantityAndLeftValid}
      // //checkPresaleQuantityStockLeftAndValid={checkQuantityAndLeftValid}
      // salesChannelAvailableQuantityOpen={salesChannelAvailableQuantityOpen}
      // salesChannelAvailablePresaleQuantityOpen={
      //   salesChannelAvailablePresaleQuantityOpen
      // }
      // onSubCollapseChange={handleOnCollapseChange}
    />
  );
};
export default StockSection;
